class ProductDescription extends HTMLElement {
  constructor() {
    super();
    this.wrapper = this.querySelector(".product__description-drawer");
    this.titleSection = this.querySelector(".product__description-drawer__title");
    this.content = this.querySelector(".product__description");
    this.button = this.querySelector(".read_more_button");
    this.expanded = false;

    theme.initWhenVisible({
      element: this,
      callback: this.init.bind(this),
      threshold: 200,
    });
  }

  init() {
    const isOverflow = this.content.children.length > 2;

    if (isOverflow) {
      this.content.children[1].innerHTML += "…";
      this.button.addEventListener("click", (e) => this.onClick(e));
      this.button.style.display = "inline-block";
    }
  }

  onClick(e) {
    e.preventDefault();

    if (this.expanded) {
      this.expanded = false;

      this.button.textContent = "Read more";
  
      for (let i = this.content.children.length; i > 2; i--) {
        this.content.children[i - 1].style.display = "none";
      }

      this.content.children[1].innerHTML += "…";

    } else {
      this.expanded = true;

      let textContent = this.content.children[1].innerHTML;
      this.content.children[1].innerHTML = textContent.replace('…', '');

      this.button.textContent = "Show less";
  
      for (const child of this.content.children) {
        child.style.display = "block";
      }
    }

  }
}

if (!customElements.get("product-description")) {
  customElements.define("product-description", ProductDescription);
}
